<template>
  <v-container>
    <h2>Profile</h2>
    <p></p>
    <v-row>
      <v-col
        cols="12"
        lg="10"
        md="12"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="admin.password"
              label="Old password"
              :rules="[rules.require]"
              type="password"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="admin.new_password"
              label="New password"
              :rules="[rules.require]"
              type="password"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="admin.confirm_password"
              label="Confirm password"
              :rules="[rules.require]"
              type="password"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="updateAdminPassword"
          >
            Update
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            @click="$router.go(-1)"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers'
export default {
  name: 'ProfileEditPassword',
  data: () => ({
    admin: {
      password: null,
      new_password: null,
      confirm_password: null
    },
    rules: {
      require: value => !!value || 'Please fill in information',
    },
  }),
  methods: {
    async updateAdminPassword () {
      try {
        if (this.requireField()) {
          await this.$http.put(`/back-office/user/password`, this.admin, authHeader())
          this.$router.push({ name: 'profile' })
        }
      } catch (err) {
        if (err.response)
          alert(err.response.data.message)
        else {
          console.log(err)
          alert('Something went wrong.')
        }
      }
    },
    requireField () {
      if (!this.admin.password || !this.admin.new_password || !this.admin.confirm_password) {
        alert('Please fill in the field(s).')
        return false
      }
      if (this.admin.new_password != this.admin.confirm_password) {
        alert('New password and confirm password are not matched.')
        return false
      }
      return true
    }
  }
}
</script>